module.exports = __webpack_public_path__ + "img/b5-3.ae3930c.png";